var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.showLoading ? _c('Loading') : _vm._e(), _c('Header', {
    attrs: {
      "title": "我的團購",
      "show-member-center": false,
      "logo": _vm.meta.header_image
    }
  }), _c('Tabs', {
    attrs: {
      "tabs": _vm.tabs,
      "activeTab": _vm.cureentTab
    },
    on: {
      "updateActiveTab": _vm.handleUpdateActiveTab
    }
  }), _c('div', {
    staticClass: "s-p-3 order-card-list"
  }, [_vm._l(_vm.groupBuyingOrders, function (groupBuyingOrder) {
    return _c('OrderCard', {
      key: groupBuyingOrder.id,
      attrs: {
        "group-buying-order": groupBuyingOrder
      },
      on: {
        "exchange": _vm.showCouponModal
      }
    });
  }), _vm.groupBuyingOrders.length === 0 ? _c('p', {
    staticClass: "text-center"
  }, [_vm._v(" " + _vm._s(_vm.showLoading ? "載入中..." : "目前沒有訂單") + " ")]) : _vm._e()], 2), _c('coupon-modal', {
    ref: "couponModal",
    attrs: {
      "coupon": _vm.selectedCoupon
    },
    on: {
      "confirmed": _vm.refresh
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }